import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/marketplace/categoryCounts';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Home-stage category tile counts. Failures are SOFT — tiles simply
// render without badges — so no global Error dispatch, matching the
// old component-side soft-fail.
function* process(action) {
  const { visibility, orgUid } = action.payload || {};
  try {
    const params = new URLSearchParams();
    if (visibility === 'org') {
      params.set('visibility', 'org');
      if (orgUid) params.set('org_uid', orgUid);
    }
    const qs = params.toString();
    const response = yield call(
      axios.get,
      `${config.API_URL}/marketplace/category-counts${qs ? `?${qs}` : ''}`,
      { headers: getLocalUser() },
    );
    const counts = response?.data?.data?.counts || response?.data?.counts || {};
    yield put(fetchSuccess(counts));
  } catch (error) {
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
